import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";

/**
 * Small badge shown only on the review account to differentiate
 * Power Pack (OTO2) features from other features.
 */
export const PowerPackBadge = ({ show }: { show: boolean }) => {
  if (!show) return null;
  return (
    <Badge className="text-[10px] px-1.5 py-0 h-5 gap-1 font-semibold bg-destructive text-destructive-foreground hover:bg-destructive/90 border-0 shadow-sm">
      <Sparkles className="h-3 w-3" />
      Power Pack
    </Badge>
  );
};
